/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_Deleted_SuccessInputs */



/**
* | output |
* | --- |
* | "KNP guide deleted successfully" |
*
* @param {Knp_Guide_Deleted_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_deleted_success = /** @type {((inputs?: Knp_Guide_Deleted_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_Deleted_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Guide KNP supprimé avec succès")
	if (locale === "de") return /** @type {LocalizedString} */ ("KNP-Leitfaden erfolgreich gelöscht")
	if (locale === "it") return /** @type {LocalizedString} */ ("Guida KNP eliminata con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Путеводитель по КНП успешно удален.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guía KNP eliminada con éxito")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("KNP 指南已成功删除")
	if (locale === "ja") return /** @type {LocalizedString} */ ("KNPガイドが正常に削除されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("केएनपी गाइड सफलतापूर्वक हटा दी गई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Guia do KNP excluído com sucesso")
	return /** @type {LocalizedString} */ ("KNP guide deleted successfully")
});